import type { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { CompanyUserRole } from "shared";
import { useCompany } from "../company/useCompany";
import { LinkGen } from "../LinkGen";

/**
 * Route guard that restricts access to full-access users only.
 * Client account users are redirected to the calendar page.
 */
export const FullAccessRoutes: FC = () => {
	const company = useCompany();
	const isClientAccount = company.myRole === CompanyUserRole.CLIENT_ACCOUNT;

	if (isClientAccount) {
		return <Navigate to={LinkGen.Calendar()} replace />;
	}

	return <Outlet />;
};

/**
 * Route guard for routes accessible to full-access users AND client account users.
 * Used for routes like Reporting that client accounts can access.
 */
export const ClientAccessRoutes: FC = () => {
	return <Outlet />;
};
